export const performancereview_Portuguese= 
{
  "id": 0,
  "name": "Avaliação de Desempenho",
  "prompts": [
    {
      "id": 1,
      "who": "Tarefa",
      "what": "Escrever uma avaliação de desempenho."
    },
    {
      "id": 2,
      "who": "Nome",
      "what": "Eric"
    },
    {
      "id": 3,
      "who": "Cargo",
      "what": "Desenvolvedor de Software Júnior"
    },
    {
      "id": 4,
      "who": "Prazos",
      "what": "Costuma cumprir os prazos. Seu código não possui bugs."
    },
    {
      "id": 5,
      "who": "Membro da equipe",
      "what": "Participa bem."
    }
  ]
}

    export const inventory_Portuguese = 
    {
      "id": 0,
      "name": "Cálculo",
      "prompts": [
        {
          "id": 1,
          "who": "Quantidade necessária:",
          "what": `sacos de café: 100\nsacos de chá: 30\novos: 3 dúzias\nleite: 5 galões`
        },
        {
          "id": 2,
          "who": "Quantidade utilizada:",
          "what": `sacos de café: 20\nleite: 2 galões\novos: 1 dúzia\ntea: 2 sacos`
        },
        {
          "id": 3,
          "who": "Tarefa:",
          "what": `O que precisa ser encomendado para reabastecer todos os itens?\nApresente os dados em formato CSV e em forma tabular.`
        },
      ]
    }
    




export const emailproperty_Portuguese = 
{
  "id": 0,
  "name": "Email",
  "prompts": [
    {
      "id": 1,
      "who": "Task",
      "what": "Escreva um e-mail sobre esta propriedade."
    },
    {
      "id": 2,
      "who": "Propriedade",
      "what": "Casa de dois andares"
    },
    {
      "id": 3,
      "who": "Quartos",
      "what": "4"
    },
    {
      "id": 4,
      "who": "Banheiros",
      "what": "3.5"
    },
    {
      "id": 5,
      "who": "Condição",
      "what": "atualização recente"
    },
    {
      "id": 6,
      "who": "Cidade",
      "what": "Evanston"
    },
    {
      "id": 7,
      "who": "Escolas",
      "what": "Escolas elementares e de segundo grau de alto nível"
    },
    {
      "id": 8,
      "who": "Restaurantes",
      "what": "Muitas opções de restaurantes sofisticados"
    },
    {
      "id": 9,
      "who": "Para:",
      "what": "John"
    },
    {
      "id": 10,
      "who": "De:",
      "what": "Marry"
    }

  ]
}


export const extraction_Portuguese=
{
  "id":0,
  "name": "Agrupar produtos",
  "prompts":[
      {
          "id":1,
          "who":"Produtos:",
          "what":"As laranjas são cultivadas na Califórnia e na Flórida. Os principais produtores de tomate estão na Flórida, as maçãs são um produto importante para o estado do Michigan. O Texas é o principal produtor de carne bovina e Wisconsin de queijo."
      },
      {
          "id":2,
          "who":"Tarefa:",
          "what":"Agrupe os seguintes produtos por região."
      },
      {
          "id":3,
          "who":"Tarefa:",
          "what":"Agrupe as regiões pelos produtos."
      }

  ]
}

    export const productdescription_Portuguese =
    {
      "id":0,
      "name": "Saco marrom",
      "prompts":[
          {
              "id":1,
              "who":"Tarefa:",
              "what":"Descreva o seguinte produto:"
          },
          {
              "id":2,
              "who":"O que:",
              "what":"Bolsa de couro"
          },
          {
              "id":3,
              "who":"Cor:",
              "what":"marrom"
          },
          {
              "id":4,
              "who":"Estilo:",
              "what":"estilo executivo"
          },
          {
              "id":5,
              "who":"Preço:",
              "what":"$79"
          },

      ]
  }
    
    
    export const floridaoranges_Portuguese= 
    {
      "id": 0,
      "name": "Laranjas da Flórida",
      "prompts": [
        {
          "id": 1,
          "who": "Relatório trimestral: Produção de laranjas na Flórida",
          "what": "Trimestre: Janeiro - Março"
        },
        {
          "id": 2,
          "who": "1. Visão geral: ",
          "what": "produção total, condições climáticas, desafios enfrentados e projeções futuras para a indústria de laranjas no estado"
        },
        {
          "id": 3,
          "who": "2. Produção Total de Laranjas",
          "what": "Total de 2,5 milhões de caixas. Aumento de 10% na produção em comparação com o mesmo período do ano passado."
        },
        {
          "id": 4,
          "who": "3. Condições Climáticas: ",
          "what": "Temperaturas moderadas, com chuvas adequadas. Eventos ocasionais de frentes frias e geadas foram observados."
        },
        {
          "id": 5,
          "who": "4. Desafios Enfrentados: ",
          "what": "Ameaça contínua de doenças cítricas, especialmente o greening cítrico. Escassez de mão de obra. Aumento do custo de produção."
        },
        {
          "id": 6,
          "who": "5. Demanda de Mercado e Exportações: ",
          "what": "Interesse estável durante o primeiro trimestre tanto doméstico quanto internacional. Aumento das vendas: Europa, Canadá."
        },
        {
          "id": 7,
          "who": "6. Projeções Futuras:",
          "what": "Produção esperada para permanecer estável. Implementação de estratégias de manejo de doenças. Monitoramento próximo do clima."
        },
        {
          "id": 8,
          "who": "7. Conclusão: ",
          "what": "Escreva um relatório com base nos fatos mencionados. Use os mesmos cabeçalhos."
        }
  
      ]
    }

    export const email_Portuguese= 
    
    {
      "id": 0,
      "name": "Email",
      "prompts": [
        {
          "id": 1,
          "who": "Para quem:",
          "what": "John Smith"
        },
        {
          "id": 2,
          "who": "Assunto: Conferência de painéis solares",
          "what": "Planejando viagem para o Havaí para a conferência anual de painéis solares."
        },
        {
          "id": 3,
          "who": "Data:",
          "what": "25-29 de setembro"
        },
        {
          "id": 4,
          "who": "Saudações:",
          "what": "Mike Thomson"
        },
        {
          "id": 5,
          "who": "Tarefa:",
          "what": "Escrever um e-mail."
        }
      ]
    }


    export const travelexpense_Portuguese= 
    {
      "id": 0,
      "name": "Despesa de viagem",
      "prompts": [
        {
          "id": 1,
          "who": "Título:",
          "what": "Mostrar isso como cabeçalho: Viagem para Nova York - despesas de viagem"
        },
        {
          "id": 2,
          "who": "Transporte:",
          "what": "Passagem aérea: $560.\nDespesas de táxi: $156"
        },
        {
          "id": 3,
          "who": "Acomodação:",
          "what": "Hotel - 2 noites: $350"
        },
        {
          "id": 4,
          "who": "Refeições:",
          "what": "Café da manhã: $56\nAlmoço: $78\nJantar: $126\nLanches: $13"
        },
        {
          "id": 5,
          "who": "Tarefa:",
          "what": "Listar todas as despesas em uma linha separada.\nNo final, mostrar o total."
        }
      ]
    }
    